module.exports = __webpack_public_path__ + "img/menu-dianyun-active.1a4c85f0.svg";